import { combineReducers } from "redux";
import session from "./session";
import page from "./page";
import profile from "./profile";
import dashboard from "./dashboard";
import unit from "./unit";
import site from "./site";
import option from "./option";
import verification from "./verification";
import event from "./event";
import vpp from "./vpp";
import wizard from "./wizard";
import version from "./version";
import ocr from "./ocr";
import replacement from "./replacement";
import photos from "./photos";

const rootReducer = combineReducers({
  session,
  page,
  profile,
  dashboard,
  unit,
  site,
  option,
  verification,
  event,
  vpp,
  wizard,
  version,
  ocr,
  replacement,
  photos
});

export default rootReducer;
